import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://passswords.visssible.com/backend';

const handleResponse = (response) => {
  const { success, data, message } = response.data;

  if (!success) {
    throw new Error(message || 'Request failed');
  }

  return data;
};

export const fetchPasswords = async () => {
  const response = await axios.get(`${API_BASE_URL}/passwords-list.php`);
  return handleResponse(response);
};

export const createPassword = async (payload) => {
  const response = await axios.post(`${API_BASE_URL}/passwords-insert.php`, payload);
  return handleResponse(response);
};

export const updatePassword = async (id, payload) => {
  const response = await axios.post(`${API_BASE_URL}/passwords-update.php`, {
    id,
    ...payload,
  });
  return handleResponse(response);
};

export const deletePassword = async (id) => {
  const response = await axios.post(`${API_BASE_URL}/passwords-delete.php`, { id });
  return handleResponse(response);
};
